<script lang="ts">
	import { Moon, Sun } from 'lucide-svelte/icons';
	import { toggleMode } from 'mode-watcher';

	import { Button } from '$lib/components/ui/button';

	import * as m from '$lib/paraglide/messages';
</script>

<Button
	onclick={toggleMode}
	variant="ghost"
	size="icon"
	class="h-7 w-7 text-muted-foreground"
	title="Toggle theme"
>
	<Sun class="scale-100 dark:scale-0" />
	<Moon class="absolute scale-0 dark:scale-100" />
	<span class="sr-only">{m.toggleTheme()}</span>
</Button>
